<template>
  <div>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fas fa-list"></i>
          Pie de página
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button class="float-right mr-3" right variant="success" @click="updateFooter">{{
          $t("public.components.organization.preferences.btnModify")
        }}
        </b-button>
      </template>
      <template v-slot:body>
        <div v-if="footers.footerLanguages">
          <b-content  v-for="(footer, index) in footers.footerLanguages" :key="index">
              <b-row>{{ footer.content.key }} - {{ footer.content.locale }}</b-row>
              <b-row>
                <ckeditor id="newHelpGlobal.content" v-model="footer.content.content" :config="configCK" type="classic"></ckeditor>
              </b-row>
          </b-content>
        </div>
      </template>
    </iq-card>
  </div>
</template>
<script>
import { xray } from "../../config/pluginInit";

import footerService from "../../services/footer";

export default {
  name: "PreferencesFooter",
  props: {
  },
  mounted() {
    xray.index();
    this.getAllFooter();
  },
  methods: {

    getAllFooter() {
      let self = this;

      this.$awn.asyncBlock(
        footerService.getAll(),
        (response) => {
          if (response) {
            self.footers = response.data;
          }
        },
        (error) => {
          log.error(error);
        },
        " "
      );
    },
    updateFooter() {
      let self = this;

      this.$awn.asyncBlock(
        footerService.update(self.footers),
        (response) => {
          if (response) {
            self.footers = response.data;
          }
        },
        (error) => {
          log.error(error);
        },
        " "
      );
    },

  },
  computed: {},
  data() {
    return {
      footers: [],
      configCK: {
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: "",
        language: "es",
        mediaEmbed: {
          previewsInData: true
        }
      },
    };
  },
  components: {},
};
</script>